import "./CookieBannerFR.css";
import { ModalContext } from "../../../../regionLayouts/FRLayout";
import { useEffect, useContext } from "react";
import {
  UpdateConsentModeRejectAll,
  UpdateConsentModeAcceptAll,
  InitializeGTM,
} from "../../../../utilities/GoogleAnalyticsEvents";
import RegionContext from "../../../../RegionContext";

function CookieBanner() {
  const region = useContext(RegionContext);
  const [, , isCookieBannerVisible, setIsCookieBannerVisible] =
    useContext(ModalContext);

  useEffect(() => {
    if (!sessionStorage.getItem("consentDecisionConfirmed")) {
      setIsCookieBannerVisible(true);
    }
  }, [setIsCookieBannerVisible]);

  function handleConsentDecision(decision) {
    if (decision === "accept") {
      UpdateConsentModeAcceptAll();
      InitializeGTM(region);
    } else if (decision === "reject") {
      UpdateConsentModeRejectAll();
    }

    sessionStorage.setItem("consentDecisionConfirmed", true);

    setIsCookieBannerVisible(false);
  }

  return (
    <div
      className={
        isCookieBannerVisible
          ? "cookie-banner-container active"
          : "cookie-banner-container"
      }
    >
      <div className="disclaimer-container">
        <p className="disclaimer-header">Ce site web utilise des cookies.</p>

        <p className="disclaimer-description">
          Nous utilisons des cookies et des technologies similaires pour assurer
          le bon fonctionnement du site web, pour mesurer notre audience, pour
          améliorer notre contenu et offrir une meilleure expérience
          utilisateur. En cliquant sur "Tout accepter" vous donnez votre
          consentement à cette utilisation telle que décrite dans notre{" "}
          <a
            style={{ color: "#365b7e", textDecoration: "none" }}
            href={"/fr/privacypolicy"}
          >
            <strong>Politique de confidentialité</strong>
          </a>
        </p>
      </div>
      <div className="consent-options-container">
        <button
          className="consent-banner-button reject-all"
          onClick={() => handleConsentDecision("reject")}
        >
          Continuer sans accepter
        </button>
        <button
          onClick={() => handleConsentDecision("accept")}
          className="consent-banner-button accept-all"
        >
          Tout accepter
        </button>
      </div>
    </div>
  );
}

export default CookieBanner;
